import { getValidToken, loadAuth } from "../lib/auth.js";

/**
 * `clawnify docs [<app-slug>]` — fetch the skill-convention README
 * for an app (or the org-level index) from the docs runtime worker.
 *
 * Hits clawnify-mcp-docs directly via its public workers.dev URL
 * with the caller's Supabase access_token. Today the docs worker
 * trusts that anyone reaching it has been authenticated upstream;
 * the CLI is the upstream for human invocation.
 *
 * For agent use, `clawnify_docs_search` (via mcp.clawnify.com) is
 * the equivalent — that path also goes through the docs worker via
 * Service Binding.
 */

const DOCS_URL = "https://clawnify-mcp-docs.workers.dev";

export async function docsCommand(
  slug: string | undefined,
  options: { caller?: string },
) {
  const token = await getValidToken();
  if (!token) {
    process.stderr.write("Not logged in. Run `clawnify login` first.\n");
    process.exit(1);
  }

  const auth = loadAuth();
  if (!auth?.org_id) {
    process.stderr.write(
      "No active org. Pick one with `clawnify org use <slug-or-id>` first.\n",
    );
    process.exit(1);
  }

  const caller = options.caller ?? "external";
  const path = slug ? `/docs/${auth.org_id}/${slug}.md?caller=${caller}` : `/docs/${auth.org_id}/index.md`;

  const res = await fetch(DOCS_URL + path, {
    headers: {
      authorization: "Bearer " + token,
    },
  });

  if (!res.ok) {
    process.stderr.write(`Failed to fetch docs: ${res.status} ${res.statusText}\n`);
    process.exit(1);
  }

  const md = await res.text();
  process.stdout.write(md);
  if (!md.endsWith("\n")) process.stdout.write("\n");
}
